const reportWebVitals = (onPerfEntry?: (entry: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals: any) => {
      const { getCLS, getFID, getFCP, getLCP, getTTFB } = webVitals as {
        getCLS: (onPerfEntry: (entry: any) => void) => void;
        getFID: (onPerfEntry: (entry: any) => void) => void;
        getFCP: (onPerfEntry: (entry: any) => void) => void;
        getLCP: (onPerfEntry: (entry: any) => void) => void;
        getTTFB: (onPerfEntry: (entry: any) => void) => void;
      };
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
